

































import { Component, Vue, Prop, Inject, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import _ from "lodash";

@Component({
  computed: {
    ...mapState("QuestionnaireAnswer", {
      questionGroupOffset: "questionGroupOffset",
      questionOffset: "questionOffset",
      showAutoSaveMsg: "showAutoSaveMsg"
    })
  }
})
export default class QConditionalQuestion extends Vue {
  @Prop({}) readonly question!: Model;
  @Inject() readonly isPreview!: boolean;

  showAutoSaveMsg!: boolean;

  ruleIndex = 0;
  isAnswerChanged = false;
  localQuestion: Model | null = null;
  oldAnswer: string[] = [];
  isLoading = false;

  get localAnswer() {
    return this.localQuestion?.value.answer;
  }
  set localAnswer(value) {
    if (this.localQuestion) {
      this.localQuestion.value.answer = value;
    }
  }

  get isDropdown() {
    return ["dropdown_single", "dropdown_multiple"].includes(
      this.question.type
    );
  }

  @Watch("localAnswer", { immediate: false })
  watchLocalAnswer(newVal) {
    let actions: string[] = [];
    if (_.isNull(newVal)) {
      actions = ["UPDATE"];
    }
    this.$parent.$emit("disable-actions", actions);
  }

  created() {
    this.isAnswerChanged = false;
    this.localQuestion = this.question;
    this.oldAnswer = this.localAnswer;

    // a quick fix for candidate height question (which has 260 as the max value), disable '.' key
    if (this.localQuestion.options.max == 260) {
      window.addEventListener('keydown', (e) => {
        if (e.key == '.') {
          e.preventDefault();
        }
      });
    }
  }

  get questionComponent() {
    if (!this.question) {
      return "";
    }
    if (this.question.type === "textinput") {
      return "q-question-text-field";
    }
    if (this.question.type === "textarea") {
      return "q-question-text-area";
    }
    if (
      this.question.type === "datepicker" &&
      this.question["options"]["range"]
    ) {
      return "q-question-date-range";
    } else if (this.question.type === "datepicker") {
      return "q-question-date";
    }
    if (this.question.type === "datetimepicker") {
      return "q-question-date-time";
    }
    if (this.question.type === "timepicker") {
      return "q-question-time";
    }
    if (this.question.type === "checkbox") {
      return "q-question-multi";
    }
    if (this.question.type === "scale") {
      return "q-question-scale";
    }
    if (this.question.type === "radiobutton") {
      return "q-question-single";
    }
    if (this.question.type === "rangeslider") {
      return "q-question-slider";
    }
    if (
      this.question.type === "dropdown_single" ||
      this.question.type === "dropdown_multiple" ||
      this.question.type === "body_parts" ||
      this.question.type === "country" ||
      this.question.type === "state"
    ) {
      return "q-question-dropdown";
    }
    if (this.question.type === "numberinput") {
      return "q-question-number-field";
    }
    return "";
  }

  async previousQuestion() {
    this.isLoading = true;
    await this.$store
      .dispatch("QuestionnaireAnswer/fetchPrevQuestion", {
        params: {
          question: this.localQuestion?.object_id,
          looped_by_value: this.localQuestion?.value.question.looped_by_value
        }
      })
      .then(response => {
        this.$parent.$emit("next", response.data.data);
      });
    this.isLoading = false;
  }

  async nextQuestion() {
    if (
      _.isNull(this.localAnswer) &&
      !["textinput", "textarea"].includes(this.question.type) &&
      this.question.options.is_required == false
    ) {
      return;
    }

    this.isLoading = true;
    await this.$store
      .dispatch("QuestionnaireAnswer/updateAnswer", {
        answer: this.localQuestion?.value.answer,
        object_id: this.localQuestion?.value.object_id,
        question: this.localQuestion?.value.question.object_id,
        looped_by_value: this.localQuestion?.value.question.looped_by_value,
        parent_answer: this.localQuestion?.value.question.parent_answer
      })
      .then(response => {
        this.$parent.$emit("next", response.data.data);
      });
    this.isLoading = false;
  }

  isInternalAnnotationExisted(question) {
    if (!question) {
      return false;
    }

    if (!question.internal_annotation) {
      return false;
    }

    if (!question.internal_annotation.length) {
      return false;
    }

    return true;
  }
}
